import { AuthenticatedTemplate } from "@azure/msal-react";
import Login from "./Login";

import { NavigationBar } from "./NavigationBar";
import { useLocation } from "react-router-dom";

export const PageLayout = (props) => {
  const location = useLocation();
  const isHealthRoute = location.pathname === "/health";

  if (isHealthRoute) {
    return props.children;
  }

  /**
   * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
   * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
   * only render their children if a user is authenticated or unauthenticated, respectively.
   */
  return (
    <>
      <NavigationBar />
      {props.children}
      <br />
      <AuthenticatedTemplate>
        <Login />
      </AuthenticatedTemplate>
    </>
  );
};
